import { useEffect, useState } from "react";
import axios from "axios";
import { FileText, FileCheck2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Downloads({ className = "", variant = "light" }) {
  const [hasLetter, setHasLetter] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/documents/meta`)
      .then(({ data }) => setHasLetter((data || []).some((d) => d.key === "determination-letter")))
      .catch(() => {});
  }, []);

  const primary =
    variant === "solid"
      ? "bg-white text-black hover:bg-white/85"
      : "border border-white/25 text-white hover:bg-white hover:text-black";

  return (
    <div className={`flex flex-wrap gap-4 ${className}`} data-testid="downloads">
      <a
        href={`${API}/case-for-support`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="download-case"
        className={`group inline-flex items-center gap-3 overline px-6 py-4 transition-colors ${primary}`}
      >
        <FileText size={15} /> Download our Case for Support
      </a>
      {hasLetter && (
        <a
          href={`${API}/documents/determination-letter`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="download-letter"
          className="group inline-flex items-center gap-3 overline px-6 py-4 border border-white/25 text-white hover:bg-white hover:text-black transition-colors"
        >
          <FileCheck2 size={15} /> 501(c)(3) Determination Letter
        </a>
      )}
    </div>
  );
}
